(function ($) {

    $(document).ready(function () {

        //HOME flex one

        $('.flex-one').flickity({
            autoPlay: true,
            draggable: true,
            cellSelector: '.slide',
            prevNextButtons: false,
            cellAlign: 'center',
            wrapAround: true,
            contain: true,
            pageDots: false,
            adaptiveHeight: true,
        });


        //SINGLE product

        $('.single-product-wrapper .carousel').flickity({
            autoPlay: true,
            autoPlay: 2000,
            draggable: true,
            cellSelector: '.slide',
            prevNextButtons: true,
            cellAlign: 'center',
            wrapAround: false,
            contain: true,
            pageDots: true,
            adaptiveHeight: true,
        });

    });

})
(jQuery);